import { render, staticRenderFns } from "./dcPxWjList.vue?vue&type=template&id=9a20d708&scoped=true&"
import script from "./dcPxWjList.vue?vue&type=script&lang=js&"
export * from "./dcPxWjList.vue?vue&type=script&lang=js&"
import style0 from "./dcPxWjList.vue?vue&type=style&index=0&id=9a20d708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a20d708",
  null
  
)

export default component.exports